export enum ESymbolRoles {
    WILD = 1,
    SCATTER = 2,
    EXPANDING_WILD_VERTICAL = 3,
    EXPANDING_WILD_HORIZONTAL = 4,
    EXPANDING_WILD_360 = 5,
    LOCK_AND_ROLL_COIN = 6,
    LOCK_AND_ROLL_BONUS_COIN = 7,
    INTERCHANGEABLE_SYMBOL = 8,
    SPECIAL_SYMBOL = 9,
    BONUS_WHEEL_SCATTER = 10,
    LOCK_AND_ROLL_DOUBLE_COIN = 11
}
